module.exports = __webpack_public_path__ + "img/ACCOUNTING.8b7da7f0.svg";